import { GetApplicationResponse } from '@iwoca/lapi-client/edge';

import { createValidatorFromYupSchema } from './stepValidators';
import { TNormalisedStepDataDE } from '../../../types';
import { minimumCompanyDataSchemaDE } from '../../CompanyDetails/CompanyDetailsDE/CompanyDetailsDE.schema';
import { minimumPersonalDataSchemaDE } from '../../PersonalDetails/PersonalDetailsDE/PersonalDetailsDE.schema';

export const passesStep0ValidationDE = (
  normalisedStep0State: TNormalisedStepDataDE['new'],
  applicationData: GetApplicationResponse['data'],
) => {
  const hasEmail = Boolean(normalisedStep0State.email);
  const hasAmount = Boolean(applicationData?.requested_products?.[0].amount);
  const hasPurpose = Boolean(applicationData?.requested_products?.[0].purpose);

  return hasEmail && hasAmount && hasPurpose;
};

export const businessStepValidatorDE = createValidatorFromYupSchema(
  minimumCompanyDataSchemaDE,
);

export const personalStepValidatorDE = createValidatorFromYupSchema(
  minimumPersonalDataSchemaDE,
);
